import { supabase } from './supabase';
import { fromDbArray, fromDb } from './mappers';

export async function fetchCollaborators(resourceType, resourceId) {
  if (!supabase) return [];
  const { data, error } = await supabase
    .from('resource_collaborators')
    .select('*')
    .eq('resource_type', resourceType)
    .eq('resource_id', resourceId);
  if (error) throw error;
  return fromDbArray('resource_collaborators', data || []);
}

export async function addInternalCollaborator(resourceType, resourceId, memberId, role) {
  if (!supabase) return null;
  const { data: { user } } = await supabase.auth.getUser();
  const { data, error } = await supabase
    .from('resource_collaborators')
    .insert({
      resource_type: resourceType,
      resource_id: resourceId,
      owner_id: user.id,
      member_id: memberId,
      collab_type: 'internal',
      role,
    })
    .select()
    .single();
  if (error) throw error;
  return fromDb('resource_collaborators', data);
}

export async function removeCollaborator(id) {
  if (!supabase) return;
  const { error } = await supabase
    .from('resource_collaborators')
    .delete()
    .eq('id', id);
  if (error) throw error;
}

export async function updateCollaboratorRole(id, role) {
  if (!supabase) return;
  const { error } = await supabase
    .from('resource_collaborators')
    .update({ role })
    .eq('id', id);
  if (error) throw error;
}

export async function generateInviteCode(resourceType, resourceId, role) {
  if (!supabase) return null;
  const { data, error } = await supabase.rpc('generate_resource_invite', {
    p_resource_type: resourceType,
    p_resource_id: resourceId,
    p_role: role,
  });
  if (error) throw error;
  return data;
}

export async function joinInviteCode(code) {
  if (!supabase) return null;
  const { data, error } = await supabase.rpc('join_resource_invite', {
    p_code: code,
  });
  if (error) throw error;
  return data;
}
